/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcCloseCircleFill({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M1.1 12C1.1 5.98 5.98 1.1 12 1.1S22.9 5.98 22.9 12 18.02 22.9 12 22.9 1.1 18.02 1.1 12m14.679-2.506a.9.9 0 1 0-1.273-1.273L12 10.727 9.493 8.221a.9.9 0 0 0-1.272 1.273L10.727 12l-2.506 2.506a.9.9 0 0 0 1.273 1.273L12 13.273l2.506 2.506a.9.9 0 0 0 1.273-1.273L13.273 12z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcCloseCircleFill;
